import DashboardVariantV2CarrierHeaderExpandMoreCollapse from './Collapse';
import DashboardVariantV2CarrierHeaderExpandMoreProvider from './Context';
import DashboardVariantV2CarrierHeaderExpandMoreDivider from './Divider';

const DashboardVariantV2CarrierHeaderExpandMoreComponents = {
  Collapse: DashboardVariantV2CarrierHeaderExpandMoreCollapse,
  Provider: DashboardVariantV2CarrierHeaderExpandMoreProvider,
  Divider: DashboardVariantV2CarrierHeaderExpandMoreDivider,
};

export default DashboardVariantV2CarrierHeaderExpandMoreComponents;
